import React, { useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useBookings } from "../hooks/useBookings";
import PanelNavigation from "../components/PanelNavigation";

export default function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  // Determinar qual aba está ativa baseado na rota
  const activeTab = useMemo(() => {
    const path = location.pathname;
    if (path.includes("/menu")) return 0;
    if (path.includes("/past")) return 1;
    if (path.includes("/upcoming")) return 2;
    // Default para próximas se estiver na raiz
    return 2;
  }, [location.pathname]);

  // Calcular dataLength para as abas de viagens
  const { rawBookings: upcomingBookings } = useBookings("upcoming");
  const { rawBookings: pastBookings } = useBookings("past");

  const dataLength = useMemo(() => {
    if (activeTab === 1) return pastBookings.length;
    if (activeTab === 2) return upcomingBookings.length;
    return 0;
  }, [activeTab, pastBookings.length, upcomingBookings.length]);

  const handleTabChange = (tabId: number) => {
    switch (tabId) {
      case 0:
        navigate("/admin-management/menu");
        break;
      case 1:
        navigate("/admin-management/past");
        break;
      case 2:
        navigate("/admin-management/upcoming");
        break;
      default:
        navigate("/admin-management/upcoming");
    }
  };

  return (
    <>
      <Outlet />
      <PanelNavigation
        value={activeTab}
        dataLength={dataLength}
        onChange={handleTabChange}
      />
    </>
  );
}
